import { extractPrices } from '../services/extractPrices';
function buildId(dimension) {
    return `${dimension.country}_${dimension.brand}_priceDisplay`;
}
export const dataLayerPriceDisplay = {
    get: (dimension) => {
        return localStorage.getItem(buildId(dimension)) ?? 'null';
    },
    set: (dimension, value) => {
        localStorage.setItem(buildId(dimension), JSON.stringify(value));
    },
};
export const priceExtractionHandler = (prices, dimension) => {
    const priceDisplay = JSON.parse(dataLayerPriceDisplay.get(dimension)) || null;
    const { primaryPrice, secondaryPrice } = extractPrices({
        prices,
        priceDisplay,
    });
    return { primaryPrice, secondaryPrice };
};
//# sourceMappingURL=dataLayerPriceDisplay.js.map